import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

// Google
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";

// Global Variables
import { CLIENT_ID } from "../../assets/GlobalVariables";

// Services
import { login, getUserDetails } from "../../services/authService";
import { useAppContext } from "../../contexts/AppContext";

// CSS
import "./googlelogin.css";

// Icons
import GoogleLogo from "../../assets/images/icons/google_logo.png";

const GoogleLoginButton = ({ googleData, onGoogleDataChange }) => {
  // Navigator
  const navigate = useNavigate();
  const { appLogin } = useAppContext();

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // Get user info using the access token
        const userInfoResponse = await fetch(
          `https://www.googleapis.com/oauth2/v2/userinfo?access_token=${tokenResponse.access_token}`
        );
        const userInfo = await userInfoResponse.json();
        
        // Create Google profile object similar to the old format
        const profileObj = {
          email: userInfo.email,
          name: userInfo.name,
          googleId: userInfo.id,
          imageUrl: userInfo.picture,
          givenName: userInfo.given_name,
          familyName: userInfo.family_name
        };

        // Save data sent by google
        onGoogleDataChange(profileObj);

        // Create data
        let data = {
          email: profileObj.email,
          password: "",
          externalID: profileObj.googleId,
        };

        // Authenticate
        let res = await login(data);

        if (res.status === "ok") {
          const user = getUserDetails();
          if (user) {
            appLogin(user);
          }
          let userType = user?.usertype;

          // Redirect user accordingly to his type
          if (userType === "clients") {
            navigate(`/p`);
          } else if (userType === "agents") {
            navigate(`/p/dashboard/home`);
          } else if (userType === "administrators") {
            navigate(`/p/administration`);
          } else {
            // pass
          }
        } else {
          // Error handler
        }
      } catch (error) {
        console.error("Google login error:", error);
      }
    },
    onError: (error) => {
      console.error("Google login failed:", error);
    },
  });

  return (
    <button className="google-login-button" onClick={handleGoogleLogin}>
      <img src={GoogleLogo} alt="Google Logo" className="google-logo" />
    </button>
  );
};

export default GoogleLoginButton;
